// @flow
import Cookies from 'js-cookie';
import React, { Component } from 'react';
import { NavDropdown, MenuItem } from 'react-bootstrap';
import locale from '../../../../../locales/index';
import style from './style';

import flagNL from './nl.png';
import flagDE from './de.png';
import flagEN from './en.png';

const language = {
  nl: { image: flagNL, title: 'Nederlands' },
  en: { image: flagEN, title: 'English' },
  de: { image: flagDE, title: 'Deutsch' },
};

class LanguageSelect extends Component<Object, {
 language: string,
}> {
  constructor(props: Object) {
    super(props);
    const startLang = (Cookies.get('language') !== undefined) ? Cookies.get('language') : locale.getLanguage();

    this.state = {
      language: startLang,
    };
  }

  click(lang: string) {
    this.setState({ language: lang });
    locale.setLanguage(lang);
    Cookies.set('language', lang);
    window.location.reload();
  }

  render(): React.Node {
    const items = [];
    const landCode = locale.getLanguage();
    const activeLAng = language[landCode] ? language[landCode] : { image: '', title: landCode };
    const Available = locale.getAvailableLanguages();

    Available.forEach((code) => {
      const data = language[code] ? language[code] : { image: '', title: code };
      const thisSelectedStyle = (this.state.language === code) ? style.selectedStyle : [];

      items.push(
        <MenuItem
          key={Math.random()}
          eventKey={3.1}
          onClick={() => this.click(code)}
          style={thisSelectedStyle}
        >
          <img style={style.flagStyle} src={data.image} alt={data.title} /> {data.title}
        </MenuItem>,
     );
    });

    const title = (<span>{activeLAng.title}</span>);

    return (<NavDropdown eventKey={3} title={title} id="language-Select-dropdown">{items}</NavDropdown>);
  }
}

export default LanguageSelect;



// WEBPACK FOOTER //
// ./src/scenes/components/Header/components/LanguageSelect/LanguageSelect.js